import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=9be6cc4c&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9be6cc4c')) {
      api.createRecord('9be6cc4c', component.options)
    } else {
      api.reload('9be6cc4c', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=9be6cc4c&", function () {
      api.rerender('9be6cc4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Text.vue"
export default component.exports